import RpmTabChart from "./RpmTabChart"

export default  RpmTabChart;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/RpmDataModal/RpmTabChart/index.js